var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarningGrayEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "14px",
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icWarningGrayEdit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.0563893,12.2511936 L9.85629933,0.748471707 C9.67534474,0.457761114 9.35044247,0.28 8.99997642,0.28 C8.64951037,0.28 8.3246081,0.457730236 8.14365351,0.748471707 L0.983627338,12.2511936 C0.797413363,12.5503646 0.791898981,12.9235178 0.969251696,13.227691 C1.14660441,13.531895 1.47928419,13.72 1.83991837,13.72 L15.2000663,13.72 C15.5607005,13.72 15.8933803,13.5318641 16.070733,13.227691 C16.2480857,12.9234869 16.2426032,12.5503646 16.0563893,12.2511936 Z M8.76493881,4.12 C9.15226737,4.12 9.48,4.34601421 9.48,4.74661648 C9.48,5.96901237 9.34096283,7.72563779 9.34096283,8.94803369 C9.34096283,9.26649697 9.00329254,9.4 8.76493881,9.4 C8.44717386,9.4 8.17900715,9.26646591 8.17900715,8.94803369 C8.17900715,7.72563779 8.04,5.96901237 8.04,4.74661648 C8.04,4.34601421 8.35776494,4.12 8.76493881,4.12 Z M8.76470886,11.32 C8.3506139,11.32 8.04,10.9833781 8.04,10.6 C8.04,10.207265 8.35058545,9.88 8.76470886,9.88 C9.15057912,9.88 9.48,10.207265 9.48,10.6 C9.48,10.9833781 9.15057912,11.32 8.76470886,11.32 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-RHP-Edit-Profile--Description",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icWarningGrayEdit",
    fill: "#A5A5A5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningGrayEdit);
export default __webpack_public_path__ + "static/media/icWarningGrayEdit.a482ea4fbe9268344326e6e2ba4427e9.svg";
export { ForwardRef as ReactComponent };